import { useState } from "react";
import { Clock, AlertTriangle, Wand2 } from "lucide-react";
import { subtaskDuration } from "../lib/subtaskDuration";

// ISO ↔ datetime-local dönüşümü (yerel saat, saniye yok).
const isoToLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
const localToIso = (v) => (v ? new Date(v).toISOString() : null);

// Alt görev SÜRE satırı: süre metni + başlangıç/bitiş düzenleme + anomali uyarısı.
// Her iç içe seviyede aynı bileşen kullanılır; rol/ekip görünümü kapısı YOKTUR.
export const SubtaskDates = ({ sub, taskId, onSetDates, compact = false }) => {
  const [open, setOpen] = useState(false);
  const dur = subtaskDuration(sub);
  const hasAny = !!(sub.start_date || sub.completed_at);

  const save = (patch) => onSetDates?.(sub.id, patch);

  return (
    <div className="mt-0.5">
      <button
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        data-testid={`subtask-duration-${taskId}-${sub.id}`}
        title="Süre ve tarihleri düzenle"
        className={`hud-text inline-flex items-center gap-1 normal-case tracking-normal transition-colors ${
          dur.anomaly ? "text-rose-300" : hasAny ? "text-violet-200 hover:text-violet-100" : "text-sertex-textMuted hover:text-sertex-cyan"
        }`}
      >
        {dur.anomaly ? <AlertTriangle className="h-2.5 w-2.5" /> : <Clock className="h-2.5 w-2.5" />}
        <span>{dur.anomaly ? "Tarihler hatalı" : dur.text}</span>
      </button>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          data-testid={`subtask-dates-editor-${taskId}-${sub.id}`}
          className="mt-1 space-y-1.5 rounded border border-violet-400/25 bg-black/30 p-1.5"
        >
          <label className="block hud-text normal-case tracking-normal text-violet-200">
            Başlangıç
            <input
              type="datetime-local"
              value={isoToLocal(sub.start_date)}
              onChange={(e) => save(e.target.value
                ? { start_date: localToIso(e.target.value), manual: true }
                : { clear_start: true })}
              data-testid={`subtask-start-input-${taskId}-${sub.id}`}
              className="mt-0.5 w-full bg-sertex-surface/60 border border-sertex-cyan/25 rounded px-1.5 py-0.5 text-[11px] font-mono text-sertex-text focus:border-sertex-cyan outline-none"
            />
          </label>
          <label className="block hud-text normal-case tracking-normal text-violet-200">
            Bitiş
            <input
              type="datetime-local"
              value={isoToLocal(sub.completed_at)}
              onChange={(e) => save(e.target.value
                ? { completed_at: localToIso(e.target.value), manual: true }
                : { clear_completed: true })}
              data-testid={`subtask-end-input-${taskId}-${sub.id}`}
              className="mt-0.5 w-full bg-sertex-surface/60 border border-sertex-cyan/25 rounded px-1.5 py-0.5 text-[11px] font-mono text-sertex-text focus:border-sertex-cyan outline-none"
            />
          </label>

          {dur.anomaly && (
            <div
              data-testid={`subtask-date-warning-${taskId}-${sub.id}`}
              className="flex items-center gap-1.5 rounded border border-rose-400/50 bg-rose-500/10 px-1.5 py-1 text-[11px] text-rose-200"
            >
              <AlertTriangle className="h-3 w-3 shrink-0" />
              <span className="flex-1">Bitiş tarihi başlangıçtan önce. Kaydedildi, ama kontrol edin.</span>
              <button
                onClick={() => save({
                  start_date: sub.completed_at, completed_at: sub.start_date, manual: true,
                })}
                data-testid={`subtask-date-fix-${taskId}-${sub.id}`}
                className="shrink-0 inline-flex items-center gap-1 rounded border border-rose-300/60 px-1.5 py-0.5 text-rose-100 hover:bg-rose-500/20"
              >
                <Wand2 className="h-3 w-3" /> Düzelt
              </button>
            </div>
          )}

          {!compact && hasAny && (
            <button
              onClick={() => save({ clear_start: true, clear_completed: true })}
              data-testid={`subtask-dates-clear-${taskId}-${sub.id}`}
              className="hud-text w-full rounded border border-sertex-cyan/25 py-0.5 text-sertex-textMuted hover:text-sertex-cyan"
            >
              TARİHSİZ YAP
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SubtaskDates;
